import { render, staticRenderFns } from "./RealtimeKpiStrip.vue?vue&type=template&id=d2874f3c&scoped=true"
import script from "./RealtimeKpiStrip.vue?vue&type=script&lang=js"
export * from "./RealtimeKpiStrip.vue?vue&type=script&lang=js"
import style0 from "./RealtimeKpiStrip.vue?vue&type=style&index=0&id=d2874f3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2874f3c",
  null
  
)

export default component.exports